import React, { useEffect, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Divider, TablePagination, Button, Switch, Grid, Typography, MenuItem, Select, TextField, TableContainer } from '@mui/material';
import { Box } from '@mui/system';
import InputStylefield from '../../assets/InputStylefield';
import { IconButton } from '@mui/material';
import { Visibility, Edit, Delete } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { deleteJobById, getAllJobs, updateJob } from '../../actions/userAuth';
import { enqueueSnackbar } from 'notistack';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';

export default function AllApplicationsTable() {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [checked, setChecked] = useState(false);
    const [date, setDate] = useState("");
    const [selectedOption, setSelectedOption] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [jobs, setJobs] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllJobs({}, (data) => {
            setJobs(data.data);
            console.log(data.data)
        }))
    }, []);

    const handleFromDateChange = (event) => {
        setFromDate(event.target.value);
    };

    const handleToDateChange = (event) => {
        setToDate(event.target.value);
    };

    const handleChange1 = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleChange = (index) => {
        var temp = [...jobs];
        temp[index].isActive = !temp[index].isActive;
        dispatch(updateJob(temp[index]._id, temp[index], {}, (data) => {
            console.log(data);
            enqueueSnackbar("Status updated successfully", { variant: 'success' });
            setJobs(temp);
        }, (err) => {
            enqueueSnackbar("Error Occrred! Please try again", { variant: 'error' });
        }))
    };

    const handleDeleteJob = (index) => {
        var temp = [...jobs];
        console.log(temp[index]._id);
        dispatch(deleteJobById(temp[index]._id, {}, (data) => {
            temp.splice(index, 1);
            setJobs(temp);
            enqueueSnackbar("Job deleted successfully", { variant: 'success' });
        }, (err) => {
            enqueueSnackbar("Error Occrred! Please try again", { variant: 'error' });
        }))
    }

    const data = [
        { id: 1, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Shortlisted', header7: 'Data 7' },
        { id: 2, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Reviewed', header7: 'Data 7' },
        { id: 3, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Rejected', header7: 'Data 7' },
        { id: 4, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Under Review', header7: 'Data 7' },
        { id: 5, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Draft', header7: 'Data 7' },
        { id: 6, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Data 6', header7: 'Data 7' },
        { id: 7, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Data 6', header7: 'Data 7' },
        // Add more data objects as needed
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const navigate = useNavigate();
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
        <Paper sx={{ px: 5, py: 2 }}>
            <Grid container my={2} >
                <Grid item md={3} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                    <Typography className='text2Bold'>Filter</Typography>
                    <select
                        style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                        className='profile-skills-box text2Light'

                        value={selectedOption}
                        onChange={handleChange}
                    >
                        <option value="">Status</option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                        <option value="option3">Option 3</option>
                    </select>
                </Grid>
                <Grid item md={7}></Grid>

              

                <Grid item md={2} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                    <select
                        style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                        className='profile-skills-box text2Light'
                        value={selectedOption}
                        onChange={handleChange}
                    >
                        <option disabled value="">
                            Sort by date
                        </option>
                        <option value="">None</option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                        <option value="option3">Option 3</option>
                    </select>
                </Grid>
            </Grid >

            <Paper>
                <Grid container>
                    <Grid item xs={12}>
                        <TableContainer sx={{ width: '100%', overflowX: 'auto' }}>
                            <Table width="auto">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'left' }}>
                                            Name
                                        </TableCell>
                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                            Applied for
                                        </TableCell>
                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                            Date
                                        </TableCell>
                                      
                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                            Status
                                        </TableCell>
                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                            Action
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(rowsPerPage > 0
                                        ? jobs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        : jobs
                                    ).map((row, index) => (
                                        <TableRow key={row.id}>
                                            <TableCell className='text2Mid' style={{ width: 'fit-content', textAlign: 'Left', color: '#2544EE', px:4}}>
                                                <p className='text2Mid' style={{ margin: '0px' }}>Anuj Sharma</p>
                                                <p className='text2Mid' style={{ margin: '0px', color:'#061C3D' }}><LocationOnOutlinedIcon sx={{color:'#000000', fontSize:'16px'}}/>Sector 44,Gurugram</p>
                                            </TableCell>
                                            <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center', }}>IT Services</TableCell>
                                      
                                            <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center', color: '', fontWeight: 'bold' }}>20/04/23 <br/>9:00AM</TableCell>
                                         
                                            <TableCell className='text2Mid' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                <Box
                                                    sx={{
                                                        color:
                                                            row.header6 === 'Rejected' || row.header6 === 'Rejected' ? '#FF0000' :
                                                                row.header6 === 'Activate' ? '#17BB05' :
                                                                    row.header6 === 'Reviewd' ? '#2544EE' :
                                                                        row.header6 === 'Reviewd' ? '#17BB05' :
                                                                           '',
                                                        px: 2,
                                                        py: 1,
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    {row.header6}
                                                </Box>
                                            </TableCell>
                                        
                                            <TableCell style={{ textAlign: 'center' }}>
                                                <Box sx={{ }}>
                                                    <IconButton aria-label="View" onClick={() => navigate(`/job-details/${row?._id}`)}>
                                                        <MailOutlineOutlinedIcon sx={{color:'#2544EE'}}/>
                                                    </IconButton>
                                                    <IconButton aria-label="Delete" onClick={() => handleDeleteJob(index)}>
                                                        <Delete sx={{color:'#2544EE'}} />
                                                    </IconButton>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}

                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 53 * emptyRows }}>
                                            <TableCell colSpan={8} />
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Paper>

    );
}
